import { useState, useEffect, useRef } from 'react';
import './Projects.scss';
import Project from '../Project/Project';
import { data } from './Data.jsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import Aos from 'aos';
import 'aos/dist/aos.css';
import 'swiper/css';
import 'swiper/css/navigation';
import * as motion from "motion/react-client"

export default function Projects() {
    const [showProjects, setShowProjects] = useState(false);
    const swiperRef = useRef(null);

    const handleMouseEnter = () => {
        swiperRef.current?.swiper?.autoplay?.stop();
    };
    
    const handleMouseLeave = () => {
        swiperRef.current?.swiper?.autoplay?.start();
    };

    useEffect(() => {
        Aos.init({ duration: 1000, once: true });
        setTimeout(() => {
            setShowProjects(true);
        }, 3000);
    }, []);

    return (
        <section id="projects" className={`projects-section ${showProjects ? 'show' : ''}`}>
            <h2 className="section-title">Personal Projects</h2>
            <motion.div 
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{
                    duration: 0.8,
                    scale: { type: "spring", bounce: 0.3, duration: 0.8 },
                }}
                viewport={{ once: true, amount: 0.4 }}
            >
                <Swiper
                    slidesPerView={1}
                    centeredSlides={false}
                    breakpoints={{
                        0: {
                          slidesPerView: 1,
                          centeredSlides: true, 
                        },
                        768: {
                          slidesPerView: 2,
                          centeredSlides: false, 
                        },
                        1380: {
                          slidesPerView: 3,
                          centeredSlides: false, 
                        },
                      }}
                    spaceBetween={30}
                    grabCursor={true}
                    autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper.el;
                    }}
                    className="projects-swiper"
                >
                        {/* <div className="projects-grid" data-aos="fade-up"> */}
                            {data.map((project, index) => (
                                <SwiperSlide key={index}  onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                                            <Project
                                                key={index}
                                                title={project.title}
                                                link={project.link}
                                                bg={project.bg}
                                                desktop={project.desktop}
                                                mobile={project.mobile}
                                                description={project.description}
                                            />
                                </SwiperSlide>
                            ))}
                        {/* </div> */}
                </Swiper>
            </motion.div>
        </section>
    );
}

